import NolanStore from "./NolanStore";

export default function Store() {
  return <NolanStore />;
}
